module.exports = __webpack_public_path__ + "static/media/12UNCTAD18.c7887c89.jpg";